<template>
    <div class="">
        <div v-if="!params.id" class="grid grid-cols-12 gap-6 mt-5">
            <div class="intro-y col-span-12 lg:col-span-6">
                <!-- BEGIN: Input -->
                <div class="intro-y box">
                    <div class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200 dark:border-dark-5">
                        <h2 class="font-medium text-base mr-auto">Información de la empresa</h2>
                    </div>
                    <div id="input" class="p-5">
                        <div v-if="user" class="preview">
                            <div>
                                <label>Nombre de la empresa</label>
                                <input v-model="user.nombre_de_la_empresa" type="text" class="input w-full border mt-2" placeholder="Nombre de la empresa" />
                            </div>
                            <div class="mt-3">
                                <label>C.I.F</label>
                                <input v-model="user.cif" type="text" class="input w-full border mt-2" placeholder="C.I.F" />
                            </div>
                            <div class="mt-3">
                                <label>Usuario</label>
                                <input v-model="user.usuario" type="text" class="input w-full border mt-2" placeholder="Usuario" />
                            </div>
                            <div class="mt-3">
                                <label>Email</label>
                                <input v-model="user.email" type="text" class="input w-full border mt-2" placeholder="Email" />
                            </div>
                            <div v-if="$d().admin" class="mt-3">
                                <label>Contraseña</label>
                                <input v-model="user.contrasena" type="password" class="input w-full border mt-2" placeholder="Contraseña" />
                            </div>
                            <div class="mt-3">
                                <label>Dirección</label>
                                <input v-model="user.direccion" type="text" class="input w-full border mt-2" placeholder="Dirección" />
                            </div>
                            <div class="mt-3">
                                <label>Teléfono</label>
                                <input v-model="user.telefono" type="text" class="input w-full border mt-2" placeholder="Teléfono" />
                            </div>
                            <div class="mt-3">
                                <label>Persona de contacto en materia de PRL</label>
                                <input v-model="user.persona_de_contacto_en_materia_de_prl" type="text" class="input w-full border mt-2" placeholder="Persona de contacto en materia de PRL" />
                            </div>
                            <div class="mt-3">
                                <label>Interlocutor válido</label>
                                <input v-model="user.interlocutor_valido" type="text" class="input w-full border mt-2" placeholder="Interlocutor válido" />
                            </div>
                            <div class="mt-3">
                                <label>Relación de actividades a desempeñar</label>
                                <input v-model="user.relacion_de_actividades_a_desempenar" type="text" class="input w-full border mt-2" placeholder="Relación de actividades a desempeñar" />
                            </div>
                        </div>
                        <div class="mt-3 flex justify-end">
                            <!-- <button v-if="$d().admin && user && user.num" @click="enviarCorreo(user.num)" class="cursor-pointer dropdown-toggle button text-white bg-theme-9 shadow-md flex items-center mr-2">
                                <SendIcon class="mr-2" />
                                Enviar correo recuperación contraseña
                            </button> -->
                            <button @click="save()" class="cursor-pointer dropdown-toggle button text-white bg-theme-1 shadow-md flex items-center">
                                <SaveIcon class="mr-2" />
                                Guardar datos
                            </button>
                        </div>
                    </div>
                </div>
                <!-- END: Input -->
            </div>
            <div class="intro-y col-span-12 lg:col-span-6">
                <!-- BEGIN: Vertical Form -->
                <div class="intro-y box" v-if="$d().admin && user && user.num">
                    <div class="flex flex-col items-start sm:items-center sm:flex-row p-5 border-b border-gray-200 dark:border-dark-5">
                        <h2 class="font-medium text-base mr-auto">Centros de trabajo</h2>
                        <a href="javascript:void(0);" data-toggle="modal" data-target="#add-modal" class="mt-2 sm:mt-0 sm:ml-auto cursor-pointer dropdown-toggle button text-white bg-theme-1 shadow-md flex items-center">
                            <PlusIcon class="mr-2" />
                            Añadir
                        </a>
                    </div>
                    <div id="vertical-form" class="p-5">
                        <ul class="preview">
                            <div v-for="(rel, index) in user.relacion_centros" :key="index" class="mb-4 flex justify-between items-center">
                                <div>
                                    <p>{{ rel.centro_bd[0].nombre_del_centro }}</p>
                                    <p class="text-gray-500 text-xs">Empleados: {{rel.lista_empleados.length}} - Subcontratas: {{rel.lista_empleados.length}}</p>
                                </div>
                                <div class="flex justify-center items-center">
                                    <button @click="editarCentroEmpresa(rel)" class="flex items-center mr-3">
                                        <CheckSquareIcon class="w-4 h-4 mr-1" />
                                        Editar
                                    </button>
                                    <button @click="eliminarCentroEmpresa(rel)" class="flex items-center text-theme-6">
                                        <Trash2Icon class="w-4 h-4 mr-1" /> Quitar
                                    </button>
                                </div>
                            </div>
                        </ul>
                    </div>
                </div>
                <!-- END: Vertical Form -->
            </div>
        </div>
        <!-- BEGIN: Add Modal -->
        <div id="add-modal" class="modal">
            <div class="modal__content">
                <div class="p-5 pb-0 text-center">
                    <div class="text-lg mt-5">Crea o selecciona el centro que deseas asignar</div>
                </div>
                <div class="px-5 pb-8 text-center">
                    <div class="mt-3">
                        <input v-model="centro_busqueda" type="text" class="input w-full border mt-2" placeholder="Escribe el nombre del centro" />
                    </div>
                    <div class="mt-3 h-48 overflow-auto border w-full rounded-lg p-1">
                        <ul>
                            <li v-if="centro_busqueda" class="flex justify-between items-center text-xs mb-1 pl-2">
                                <p class="text-gray-500">No se encuentran centros con el término escrito</p>
                                <button @click="crearCentro" type="button" class="button w-24 bg-theme-10 text-white">
                                    Crear nuevo
                                </button>
                            </li>
                            <li v-for="(centro, index) in centros" :key="index" class="flex justify-between items-center text-xs mb-1 pl-2">
                                <p>{{centro.nombre_del_centro}}</p>
                                <!-- <p class="text-gray-500">0 empresas asignadas</p> -->
                                <button @click="seleccionarCentro(centro.num)" type="button" class="button w-24 bg-theme-9 text-white">
                                    Seleccionar
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- END: Add Modal -->
        <!-- BEGIN: Edit Modal -->
        <div v-if="params.id && centroSeleccionado" id="edit-modal" class="modal2">
            <div class="modal__content">
                <div class="p-5 pb-0 mb-8">
                    <div class="text-xl mt-5">Gestionar plantillas de archivos para <b>{{ centroSeleccionado.name }}</b></div>
                </div>
                <div class="px-5 pb-8 text-center">
                    <carga-tabs :centro="centroSeleccionado" :adminView="true"></carga-tabs>
                </div>
            </div>
        </div>
        <!-- END: Edit Modal -->
        <modal :data="{ 'id':'save-confirmation-modal', 'title':'Guardado', 'text':'Los datos han sido guardados', 'icon':'check'}"></modal>
        <modal :data="{ 'id':'delete-confirmation-modal', 'title':'Error', 'text':'Error en el guardado de datos. Vuelve a intentarlo', 'icon':'x'}" @confirm="confirmRemove"></modal>
        <!-- BEGIN: Centro Empresa Modal -->
        <div v-if="relacion" id="centro-empresa-modal" class="fixed top-0 left-0 w-screen h-screen z-100">
            <div @click="relacion = null" class="bg-black opacity-50 absolute top-0 left-0 w-full h-full p-16"></div>
            <div class="w-full h-full overflow-auto flex justify-center items-center">
                <div class="modal__content relative bg-white rounded max-w-2xl">
                    <div class="p-5 pb-0 text-center">
                        <div class="text-lg mt-5">Selecciona los documentos que debe aportar la empresa / sus subcontratas / empleados.</div>
                    </div>
                    <div class="px-5 pb-8 text-center">
                        <div class="mt-3 h-64 overflow-auto border w-full rounded-lg p-1 bg-white">
                            <ul class="overflow-auto h-full relative">
                                <li class="flex sticky top-0 left-0 right-0 p-2 bg-white">
                                    <div class="w-6/12">Documento</div>
                                    <div class="w-2/12">Mostrado</div>
                                    <div class="w-2/12">Opcional</div>
                                    <div class="w-2/12">Fecha Cad.</div>
                                </li>
                                <li v-for="index in relacion_plantillas_ordenadas" class="flex justify-between items-center text-xs mb-2 p-2">
                                    <div class="w-6/12 text-left">{{$d().user.plantillas[index]}}</div>
                                    <div v-if="relacion.config_plantillas[index].allow_config" class="w-2/12 flex justify-center items-center">
                                        <CircleIcon class="cursor-pointer" @click="relacion.config_plantillas[index].solicitar_por_defecto = 1" v-if="!relacion.config_plantillas[index].solicitar_por_defecto" />
                                        <CheckCircleIcon class="text-green-600 cursor-pointer" @click="relacion.config_plantillas[index].solicitar_por_defecto = 0" v-if="relacion.config_plantillas[index].solicitar_por_defecto" />
                                    </div>
                                    <div v-if="relacion.config_plantillas[index].allow_config" class="w-2/12 flex justify-center items-center">
                                        <CircleIcon class="cursor-pointer" @click="relacion.config_plantillas[index].opcional_por_defecto = 1" v-if="!relacion.config_plantillas[index].opcional_por_defecto" />
                                        <CheckCircleIcon class="text-green-600 cursor-pointer" @click="relacion.config_plantillas[index].opcional_por_defecto = 0" v-if="relacion.config_plantillas[index].opcional_por_defecto" />
                                    </div>
                                    <div v-if="relacion.config_plantillas[index].allow_config" class="w-2/12 flex justify-center items-center">
                                        <CircleIcon class="cursor-pointer" @click="relacion.config_plantillas[index].fecha_caducidad = 1" v-if="!relacion.config_plantillas[index].fecha_caducidad" />
                                        <CheckCircleIcon class="text-green-600 cursor-pointer" @click="relacion.config_plantillas[index].fecha_caducidad = 0" v-if="relacion.config_plantillas[index].fecha_caducidad" />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="px-8">
                        <p><strong>Mostrar</strong>: En caso de que esté marcado, el usuario podrá subir archivos relacionados con esa plantilla.</p>
                        <p><strong>Opcional</strong>: En caso de que esté marcado, la subida de archivos será algo opcional. No se contará para el total de archivos pendientes ni apareceré como requerido para el usuario.</p>
                        <p><strong>Fecha Cad</strong>: En caso de que esté marcado, el usuario podrá seleccionar una fecha en la que se caduque el archivo.</p>
                    </div>
                    <div class="p-4 justify-end flex">
                        <button @click="guardarCentroEmpresa()" class="cursor-pointer dropdown-toggle button text-white bg-theme-1 shadow-md flex items-center">
                            <SaveIcon class="mr-2" />
                            Guardar datos
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- END: Centro Empresa Modal -->
    </div>
</template>
<script>
import CargaTabs from "@/components/CargaTabs";
import Modal from "@/global-components/Modal";


export default {
    components: {
        CargaTabs,
        Modal
    },
    data() {
        return {
            centros: [],
            centro_busqueda: '',
            params: {},
            user: null,
            centroSeleccionado: null,
            relacion: null,
            relacion_plantillas_ordenadas: null
        }
    },
    watch: {
        params: function(newVal, oldVal) {
            this.centroSeleccionado = null;
            if (newVal && newVal.id) this.centroSeleccionado = this.$f()[0].users[0];
        },
        centro_busqueda: function(newVal, oldVal) {
            this.centros = this.$d().user.centros.filter(each => each.nombre_del_centro.toLowerCase().match(newVal.toLowerCase()));
        }
    },
    mounted() {
        window.bus.$on('dataReloaded', () => {
            this.reload();
        })
        this.reload();
    },
    methods: {
        reload() {
            if (this.centro_busqueda) {
                this.centros = this.$d().user.centros.filter(each => each.nombre_del_centro.toLowerCase().match(this.centro_busqueda.toLowerCase()))
            } else {
                this.centros = this.$d().user.centros;
            }
            this.user = {
                num: this.$d().user.num ? this.$d().user.num : null,
                nombre_de_la_empresa: this.$d().user.nombre_de_la_empresa ? this.$d().user.nombre_de_la_empresa : '',
                cif: this.$d().user.cif ? this.$d().user.cif : '',
                usuario: this.$d().user.usuario ? this.$d().user.usuario : '',
                email: this.$d().user.email ? this.$d().user.email : '',
                contrasena: this.$d().user.contrasena ? this.$d().user.contrasena : '',
                direccion: this.$d().user.direccion ? this.$d().user.direccion : '',
                telefono: this.$d().user.telefono ? this.$d().user.telefono : '',
                persona_de_contacto_en_materia_de_prl: this.$d().user.persona_de_contacto_en_materia_de_prl ? this.$d().user.persona_de_contacto_en_materia_de_prl : '',
                interlocutor_valido: this.$d().user.interlocutor_valido ? this.$d().user.interlocutor_valido : '',
                relacion_de_actividades_a_desempenar: this.$d().user.relacion_de_actividades_a_desempenar ? this.$d().user.relacion_de_actividades_a_desempenar : '',
                relacion_centros: this.$d().user.relacion_centros ? this.$d().user.relacion_centros : [],
            }
            this.update(this.$router.currentRoute);
            this.$router.beforeEach((to, from, next) => {
                this.update(to);
                next();
            })
        },
        seleccionarCentro(num) {
            CmsApi.hook("/hooks/save/", { action: 'crear_centro_empresa', data: JSON.stringify({ centro: num, empresa: this.user.num }) }, (data) => {
                if (data.success) {
                    window.bus.$emit("reloadDataFromServer", data);
                    this.closeModals();
                }
            });
        },
        crearCentro() {
            CmsApi.hook("/hooks/save/", { action: 'save_centro', data: JSON.stringify({ nombre_del_centro: this.centro_busqueda, empresa: this.user.num }) }, (data) => {
                if (data.success) {
                    window.bus.$emit("reloadDataFromServer", data);
                    this.closeModals();
                }
            });
        },
        guardarCentro(centro) {
            CmsApi.hook("/hooks/save/", { action: 'save_centro', data: JSON.stringify({ centro: centro.num, nombre_del_centro: centro.nombre_del_centro }) }, (data) => {
                if (data.success) {
                    window.bus.$emit("reloadDataFromServer", data);
                    this.closeModals();
                }
            });
        },
        save() {
            CmsApi.hook("/hooks/save/", { action: 'empresa', data: JSON.stringify(this.user) }, (data) => {
                if (data.success) {
                    cash("#save-confirmation-modal").modal("show");
                    window.bus.$emit("reloadDataFromServer", data);
                } else {
                    cash("#delete-confirmation-modal").modal("show");
                }
            });
        },
        enviarCorreo(num) {
            if (confirm('Se enviará un correo al usuario para que reestablezca su contraseña. ¿Desea continuar? \n\n- POR FAVOR, guarde la información antes de continuar')) {
                CmsApi.hook("/hooks/send_restore_password/", { empresa: num }, (data) => {
                    if (data.success) {
                        alert('Se ha enviado correo al usuario.');
                    } else {
                        alert('No se pudo realizar la acción. Motivo: ' + data.error);
                    }
                });
            }
        },
        editarCentroEmpresa(rel) {
            let num_plantillas = [];
            Object.keys(rel.config_plantillas).forEach(key => {
                num_plantillas.push({num: key, order: parseInt(rel.config_plantillas[key].globalOrder)})
            })
            num_plantillas.sort((a,b) => {
                if(a.order > b.order) return 1;
                if(a.order == b.order) return 0;
                if(a.order < b.order) return -1;
            });
            this.relacion_plantillas_ordenadas = num_plantillas.map(a => a.num);
            this.relacion = rel;
        },
        eliminarCentroEmpresa(rel) {
            if (confirm('Con esta acción se va a eliminar la relación de este centro con esta empresa ¿Está seguro?')) {
                CmsApi.hook("/hooks/save/", { action: 'desactivar_centro_empresa', data: JSON.stringify({ centro_empresa: rel.num }) }, (data) => {
                    if (data.success) {
                        window.bus.$emit("reloadDataFromServer", data);
                    }
                });
            }
        },
        guardarCentroEmpresa() {
            CmsApi.hook("/hooks/save/", { action: 'editar_centro_empresa', data: JSON.stringify({ centro_empresa: this.relacion }) }, (data) => {
                if (data.success) {
                    cash("#save-confirmation-modal").modal("show");
                    window.bus.$emit("reloadDataFromServer", data);
                    this.relacion = null;
                    this.relacion_plantillas_ordenadas = null;
                } else {
                    cash("#delete-confirmation-modal").modal("show");
                }
            });
        },
        closeModals() {
            document.querySelectorAll('.modal').forEach(each => each.click());
        },
        update(to) {
            this.params = {};
            if (to.params) this.params = to.params;
        },
        confirmRemove() {
            alert("Confirmamos remove");
        }
    }
};
</script>